import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
const TableColumnSelectorTooltipIcon = _ref => {
  let {
    className,
    columnName,
    icon,
    tooltipIdSuffix,
    tooltipText
  } = _ref;
  return /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "top",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      "data-testid": `table-column-selector-${columnName}-${tooltipIdSuffix}-tooltip`,
      id: `table-column-selector-${columnName}-${tooltipIdSuffix}-tooltip`
    }, tooltipText)
  }, /*#__PURE__*/React.createElement("span", {
    "aria-label": tooltipText,
    className: `${className} material-icons md-18`,
    "data-testid": `table-column-selector-${columnName}-${tooltipIdSuffix}-icon`,
    role: "img"
  }, icon));
};
export default TableColumnSelectorTooltipIcon;